/**
 * [提现]
 * @Author: Fu Xiaochun
 * @Email:  f2e.xiaochun@gmail.com
 */

import React, { useState, useEffect } from 'react';
import styles from './modal.module.scss';
import { Modal, Form, Input, Button, Select, InputNumber, message } from 'antd';
import { regFenToYuan, regYuanToFen, priceUppercase } from '@/util/money';
import * as apis from '@/apis/finance/platformAccount';

function WithdrawalModal(props){

    const accounts = [{value: '31020401040006542', label: '31020401040006542(对公账户)'}];

    const [toAccount, setToAccount] = useState({value: '31020401040006542'});
    const [amount, setAmount] = useState();
    const [remark, setRemark] = useState();

    const onClose = ()=>{
        props.onClose();
    };

    const onSubmit = ()=>{
        if(!amount){
            message.error('请输入提现金额');
            return false;
        }

        let formData = {
            cardNO: toAccount.value,
            amount: regYuanToFen(amount),
            remark,
        };
        apis.lianlianPlatformWithdrawal(formData).then(res=>{
            message.success('操作成功');
            props.onOk();
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onRemarkChange = (e)=>{
        let val = e.target.value || '';
        val = val.trim();
        setRemark(val);
    };

    return <>
        <Modal visible={true} centered title="收益户提现" width="700px" onOk={onSubmit} onCancel={onClose}>
            <div className={styles.formBox}>
                <div className={styles.formItem}>
                    <div className={styles.label}>充值账户：</div>
                    <div className={styles.val}>2527263571630374</div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>当前余额：</div>
                    <div className={styles.val}>{regFenToYuan(props.balance)}</div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>转至账户：</div>
                    <div className={styles.val}>
                        <Select className={styles.txt} labelInValue value={toAccount} options={accounts}/>
                    </div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>提现金额：</div>
                    <div className={styles.val}>
                        <InputNumber className={styles.txt} placeholder="请输入提现金额" min={0} max={regFenToYuan(props.balance)} precision={2} value={amount} onChange={setAmount} />
                        <p>金额大写：{priceUppercase(amount)}</p>
                    </div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>提现留言：</div>
                    <div className={styles.val}>
                        <Input.TextArea className={styles.txts} placeholder="请输入提现留言或原因" value={remark} onChange={onRemarkChange}></Input.TextArea>
                    </div>
                </div>
            </div>
        </Modal>
    </>
}

export default WithdrawalModal;